import React from 'react';
import {ElementId} from './types';
import {TranslatedWord} from './FieldConfiguration';
import getLanguage, {LanguageId} from '../utils/Languages';
import IconError from '../../components/icon/IconError';

export default abstract class ElementConfiguration {
  id: ElementId
  labels: TranslatedWord[]
  editable: boolean
  protected elementName: string

  abstract getLabel(languageId: LanguageId): string

  protected getTranslationNotice(
    label: string,
    activeLanguage: LanguageId,
    defaultLanguage: LanguageId,
  ): React.ReactNode {
    const withTranslation = label.length > 0;
    const anyName = this.labels.find((x) => x.translation.length !== 0);

    if (withTranslation) {
      return <span>{label} (<IconError
        className="text-yellow"/> Translation recommended for {getLanguage(defaultLanguage)})</span>;
    }
    return <span><IconError
      className="text-red"/> Translation required for {getLanguage(activeLanguage)} {anyName &&
    <span
      className="font-normal text-gray-dark">(name of the {this.elementName} in {getLanguage(anyName.language)} is <b>{anyName.translation}</b>)
    </span>}
    </span>;
  }
}
